import { memo } from 'react';

const CheckComponent = () => (
  <svg fill="none" height="10" viewBox="0 0 12 10" width="12" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.9942 1.02318C10.6674 0.674813 10.1322 0.674813 9.80536 1.02318L4.08234 7.11731L2.18487 5.09475C1.85805 4.74638 1.32287 4.74638 0.996049 5.09475C0.677346 5.43446 0.677346 5.97786 0.996049 6.31757L3.49083 8.97682C3.81765 9.32519 4.35283 9.32519 4.67965 8.97682L10.9942 2.246C11.3129 1.90629 11.3129 1.36289 10.9942 1.02318Z" fill="white" stroke="white" strokeWidth="0.47619"/>
  </svg>
);

export const Check = memo(CheckComponent);
